// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the Apache License. See License in the project root for license information.

/**
 * Describes the default operation timeout in seconds. Value: `60`.
 */
export const defaultOperationTimeoutInSeconds = 60;
